export interface MarketoValidator {
    validate: (input: string) => boolean;
    errorMessage: string;
}
export const phoneNumberValidator: MarketoValidator = {
    validate: function phoneNumberValidator(phoneNumber) {
        const PHONE_REGEX = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/;
        return PHONE_REGEX.test(phoneNumber);
    },
    errorMessage: gettext('Please enter a valid phone number.'),
};

export const genericEmailValidator: MarketoValidator = {
    validate: function genericEmailValidator(email) {
        const EMAIL_REGEX =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return EMAIL_REGEX.test(email);
    },
    errorMessage: gettext('Please enter a valid email address'),
};

export const businessEmailValidator: MarketoValidator = {
    validate: function businessEmailValidator(email) {
        const DISALLOWED_DOMAINS = [
            '@outlook.',
            '@gmail.',
            '@yahoo.',
            '@qq.',
            '@yandex.',
            '@inbox.',
            '@aol.',
            '@me.',
            '@mac.',
            '@icloud.',
            '@mail.com',
            '@hotmail.',
            '@protonmail.',
        ];

        return !DISALLOWED_DOMAINS.some((domain) => (email || '').toLowerCase().includes(domain));
    },
    errorMessage: gettext('Please enter a valid work email address.'),
};
